export default "__VITE_ASSET__19c11f02__"